<template>
  <TableStatic :loading="loading" :rows="rows" :columns="columns" :line-numbers="lineNumbers">
    <template slot="table-row" slot-scope="props">
      <template v-if="props.column.field === 'salaryAmount'">
        {{ (props.row.salaryAmount * 100) | currency }}
      </template>
      <template v-else-if="props.column.field === 'salaryFee'">
        {{ (props.row.salaryFee * 100) | currency }}
      </template>
      <div v-else-if="props.column.field === 'paid'" class="whitespace-nowrap text-left">
        <div :class="['status', `is-${props.row.paid === '1' ? 'confirmed' : 'pending'}`]">
          {{
            props.row.paid === '1' ? $t('socialInsurance.paidYes') : $t('socialInsurance.paidNo')
          }}
        </div>
      </div>
    </template>
  </TableStatic>
</template>

<script>
import TableStatic from '@/components/ui/table/TableStatic';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';

export default {
  mixins: [tableMixin],
  components: {
    TableStatic,
  },
  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
